var React = require('react');

function Rank (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z","key":1})]);
}

Rank.defaultProps = {"viewBox":"0 0 24 24","fill":"#ffffff"};

module.exports = Rank;

Rank.default = Rank;
